import { makeAutoObservable } from 'mobx';

import { TReverseParam, isReverseModeAllowed, reverseParams } from 'constants/extraParams';
import {
  TReverseMode,
  TReverseModes,
  TReverseSource,
  extractReverseModes,
  getEmptyReverseModes,
  reverseModesToFilterFields,
} from 'store/FilterStore/Mappers/ReverseModes';
import { RootStore } from 'store/RootStore';
import { SiteFeaturesIDs } from 'store/SiteFeatures/SiteFeatures';

class ReverseParams {
  root: RootStore;
  modes: TReverseModes;

  constructor(root: RootStore) {
    this.root = root;
    this.modes = getEmptyReverseModes();

    makeAutoObservable(this);
  }

  get isEnabled() {
    return Boolean(this.root.siteFeatures.isSiteFeatureEnabled[SiteFeaturesIDs.reverseFilters]);
  }

  get excludedCount() {
    return Object.values(this.modes).filter(mode => mode === 'exclude').length;
  }

  get isDefault() {
    return Object.values(this.modes).every(mode => mode === null);
  }

  get requestData() {
    return reverseModesToFilterFields(this.modes);
  }

  isIncluded = (param: TReverseParam) => this.modes[param] === 'include';

  isExcluded = (param: TReverseParam) => this.modes[param] === 'exclude';

  clearMode = (param: TReverseParam) => {
    this.modes[param] = null;

    if (param === reverseParams.adr) {
      this.root.filter.ADR.clear();
    }
  };

  setMode = (param: TReverseParam, mode: TReverseMode) => {
    if (!isReverseModeAllowed(param, mode)) return;

    if (this.modes[param] === mode) {
      this.clearMode(param);
    } else {
      this.modes[param] = mode;
    }
  };

  resetExcluded = () => {
    Object.values(reverseParams).filter(this.isExcluded).forEach(this.clearMode);
  };

  fillFromFilterData = (filterData: TReverseSource) => {
    this.modes = extractReverseModes(filterData);

    if (this.isIncluded(reverseParams.adr) && filterData.adr?.ids?.length) {
      this.root.filter.ADR.selectOptionsByIds(filterData.adr.ids);
    } else {
      this.root.filter.ADR.clear();
    }
  };

  reset = () => {
    (Object.keys(this.modes) as TReverseParam[]).forEach(param => {
      this.modes[param] = null;
    });

    if (this.isEnabled) {
      this.root.filter.ADR.clear();
    }
  };
}

export { ReverseParams };
